export default function PHP_Sessions() {
  return (
    <div>
      <h1>PHP_Sessions</h1>
    </div>
  );
}
